import React from 'react';
import Link from 'next/link';
import logoBrand from '../../assets/img/header/logo.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src={logoBrand.src || logoBrand}
                alt="Logo"
                style={{ height: "40px", objectFit: "contain" }}
              />
            </div>
            <p className="footer-desc">
              Delivering Excellence,
              <br />
              Righteously
            </p>
          </div>

          <div className="footer-links-wrapper">
            <div className="footer-links-col">
              <h4 className="footer-col-title">Company</h4>
              <a href="#" className="footer-link">Our Story</a>
              <a href="#" className="footer-link">Process</a>
              <a href="#" className="footer-link">Engagement Model</a>
              <a href="#" className="footer-link">Blog</a>
              <Link href="/contactus" className="footer-link">Contact Us</Link>
              <a href="#" className="footer-link">Privacy Policy</a>
            </div>

            <div className="footer-links-col">
              <h4 className="footer-col-title">Resources</h4>
              <Link href="/casestudy/casestudy" className="footer-link">Case Study</Link>
              <a href="#" className="footer-link">Testimonials</a>
              <a href="#" className="footer-link">Life @ Chudasama Outsourcing</a>
              <a href="#" className="footer-link">Resources</a>
              <a href="#" className="footer-link">Careers</a>
              <a href="#" className="footer-link">Our Clients</a>
            </div>

            <div className="footer-links-col">
              <h4 className="footer-col-title">Services</h4>
              <a href="#" className="footer-link">Cloud Consulting</a>
              <a href="#" className="footer-link">Resource As A Service</a>
              <a href="#" className="footer-link">DevOps Services</a>
              <a href="#" className="footer-link">IoT (Internet of Things)</a>
              <a href="#" className="footer-link">Product Engineering</a>
              <a href="#" className="footer-link">Digital Transformation</a>
            </div>


            <div className="footer-links-col">
              <h4 className="footer-col-title">Have Questions?</h4>
              <a href="mailto:Info@Chudasamaoutsourcing.Com" className="footer-link">
                Info@Chudasamaoutsourcing.Com
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            Copyright 2011-2026 Chudasama Outsourcing All Rights Reserved.
          </p>
          <div className="footer-socials">
            {/* Social icons kept as they were */}
            <a href="#" className="social-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>
            <a href="#" className="social-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
              </svg>
            </a>
            <a href="#" className="social-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
            <a href="#" className="social-icon" style={{ fontWeight: "900", fontSize: "var(--font-size-caption)", fontFamily: "var(--font-heading)" }}>p</a>
            <a href="#" className="social-icon" style={{ fontWeight: "800", fontSize: "var(--font-size-caption)" }}>Bē</a>
            <a href="#" className="social-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
            <a href="#" className="social-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.6 14.4c-.13.22-.44.29-.66.16-1.82-1.11-4.11-1.36-6.81-.75-.25.06-.51-.1-.57-.36-.06-.25.1-.51.36-.57 2.95-.66 5.48-.38 7.5.57.23-.13.29-.44.18-.66zm1.4-3.14c-.16.27-.53.37-.82.2-2.08-1.28-5.26-1.66-7.85-.92-.32.09-.66-.09-.75-.41-.09-.32.09-.66.41-.75 2.94-.84 6.46-.42 8.81 1.02.29.17.39.55.2.28zm.12-3.32C15.65 8.5 11.66 8.36 8.5 9.32c-.39.12-.8-.11-.92-.51-.12-.39.11-.8.51-.92 3.65-1.11 8.23-.94 11.19.82.35.21.46.68.25 1.03-.21.36-.68.47-1.03.26z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
